export default {
  title: 'Global discounts/charges before taxes'
}
